import React from 'react';
import './Blog.css';
import AIBanner from '../Assets/blogg.jpeg';
import MLImage from '../Assets/bloga.jpeg';
import AIImage from '../Assets/blog6.jpg';
import LTEImage from '../Assets/blog1.jpg';
import { FaRobot, FaBrain, FaNetworkWired } from 'react-icons/fa';
import { MdOutlineScience, MdSpeed } from 'react-icons/md';

const Blog = () => {
  const technologies = [
    {
      id: 1,
      title: "Artificial Intelligence",
      description: "Explore how AI is transforming industries with intelligent automation, predictive analytics, and cognitive computing capabilities.",
      icon: <FaRobot className="tech-icon" />,
      image: AIImage,
      category: "AI/ML",
    },
    {
      id: 2,
      title: "Machine Learning",
      description: "Discover the power of ML algorithms in pattern recognition, data analysis, and creating self-improving systems.",
      icon: <FaBrain className="tech-icon" />,
      image: MLImage,
      category: "AI/ML",
    },
    {
      id: 3,
      title: "LTE (4G) Technology",
      description: "Learn about high-speed 4G networks enabling IoT connectivity, mobile broadband, and low-latency communications.",
      icon: <FaNetworkWired className="tech-icon" />,
      image: LTEImage,
      category: "Connectivity",
    },
    {
      id: 4,
      title: "AI in Network Optimization",
      description: "How artificial intelligence is revolutionizing network management and 4G/5G performance optimization.",
      icon: <MdOutlineScience className="tech-icon" />,
      image: AIImage,
      category: "AI/ML",
    },
    {
      id: 5,
      title: "4G LTE Advanced",
      description: "The evolution of LTE technology delivering faster speeds, improved coverage, and enhanced capacity for modern applications.",
      icon: <MdSpeed className="tech-icon" />,
      image: LTEImage,
      category: "Connectivity",
    },
    {
      id: 6,
      title: "ML for Predictive Maintenance",
      description: "Machine learning applications in predicting equipment failures and optimizing maintenance schedules in telecom networks.",
      icon: <FaBrain className="tech-icon" />,
      image: MLImage,
      category: "AI/ML",
    },
  ];

  return (
    <div className="tech-blog-container">
      {/* Hero Banner */}
      <div className="blog-hero">
        <img src={AIBanner} alt="AI and LTE Technologies" className="hero-image" onError={(e) => { e.target.src = 'https://via.placeholder.com/1200x500'; }} />
        <div className="hero-content">
          <h1>AI/ML & LTE Technology Insights</h1>
          <p>Exploring the convergence of artificial intelligence and high-speed connectivity</p>
        </div>
      </div>

      {/* Main Content */}
      <main className="blog-main">
        {/* Featured Articles */}
        {/* <section className="featured-section">
          <h2 className="section-title">Featured Technologies</h2>
          <div className="featured-grid">
            {technologies.slice(0, 3).map(tech => (
              <div key={tech.id} className="featured-card">
                
                <div className="card-content">
                  <div className="card-meta">
                    
                  </div>
                  <h3>{tech.title}</h3>
                  <p>{tech.description}</p>
                  <button className="read-more-btn">
                    Read Article <span>→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section> */}

        {/* All Technology Articles */}
        <section className="articles-section">
          <h2 className="section-title">Latest Technology Articles</h2>
          <div className="filter-tabs">
            <button className="filter-btn active">All</button>
            <button className="filter-btn">AI/ML</button>
            <button className="filter-btn">LTE (4G)</button>
          </div>
          
          <div className="articles-grid">
            {technologies.map(tech => (
              <div key={tech.id} className="article-card">
                <div className="article-image">
                  <img src={tech.image} alt={tech.title} onError={(e) => { e.target.src = 'https://via.placeholder.com/350x200'; }} />
                  <div className="category-tag">{tech.category}</div>
                </div>
                <div className="article-content">
                  <div className="article-meta">
                    {/* Date removed */}
                    {tech.icon}
                  </div>
                  <h3>{tech.title}</h3>
                  <p>{tech.description}</p>
                  <button className="article-link">
                    Continue Reading <span>→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Newsletter Subscription */}
        <section className="newsletter-section">
          <div className="newsletter-container">
            <h3>Stay Updated with Tech Trends</h3>
            <p>Subscribe to our newsletter for the latest in AI, ML, and connectivity technologies</p>
            <div className="subscribe-form">
              <input type="email" placeholder="Your email address" />
              <button className="subscribe-btn">Subscribe</button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Blog;